import { Paper } from '@mui/material';
import { withDefault } from '@weft/utils';
import { isNotProduction } from 'apps/app/src/utils/env-indicator';
import { Helmet } from 'react-helmet';
import { Link, useSearchParams } from 'react-router-dom';
import { withPageLayout } from '../../../components/new-design/layout/VyPageLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { useMeasurementsStats } from '../../../hooks/requests/use-measurements-stats';
import { useFromDayParam } from '../../../hooks/search-params/use-from-day-param';
import { useToDayParam } from '../../../hooks/search-params/use-to-day-param';
import { DataMeteringContent } from './data-metering-components/DataMeteringContent';
import { DataMeteringFiltersContent } from './data-metering-components/DataMeteringFiltersContent';
import { useDataMeteringParamsIds } from './data-metering-types/data-metering-filters-params';

const DataMeteringPage = () => {
  const [searchParams] = useSearchParams();

  const [paramsDayFrom] = useFromDayParam();
  const [paramsDayTo] = useToDayParam();

  const startTime = paramsDayFrom?.toDate();
  const endTime = paramsDayTo?.toDate();
  const { customersIds, metersIds, eventNames } = useDataMeteringParamsIds(searchParams);

  const { data: measurementsStatsResponse, isLoading: isLoadingMeasurementsStats } = useMeasurementsStats({ startTime, endTime, customersIds, eventNames, metersIds });

  const measurementsStats = withDefault(measurementsStatsResponse?.measurementsStats, []);

  return (
    <>
      <Helmet>
        <title>Data Metering</title>
      </Helmet>

      <Paper
        variant="outlined"
        sx={theme => ({
          borderRadius: '12px',
          boxShadow: theme.shadows[1],
          height: '100%',
          overflow: 'hidden',
          position: 'relative',
        })}
      >
        <DataMeteringFiltersContent
          measurementsStats={measurementsStats}
          eventNames={withDefault(eventNames, [])}
        />

        <DataMeteringContent
          measurementsStats={measurementsStats}
          isLoading={isLoadingMeasurementsStats}
        />
      </Paper>
    </>
  );
};

const DataMeteringPageWithSuspenseBoundary = withPageLayout(withGlobalSearchParams(DataMeteringPage), {
  title: 'Usage',
  path: ['Data Metering', 'Usage'],
  action: isNotProduction()
    ? (
      <Link
        className='text-blue-600 underline hover:text-blue-800'
        to="admin"
      >
        Admin
      </Link>
    )
    : <></>,
});
export { DataMeteringPageWithSuspenseBoundary as DataMeteringPage };